<button class="cass-button-dropdown" mat-stroked-button [matMenuTriggerFor]="menu">
	{{ buttonLabel }}
	<mat-icon *ngIf="!hideIcon" iconPositionEnd>arrow_drop_down</mat-icon>
</button>

<mat-menu class="cass-button-dropdown-menu-item" #menu="matMenu">
	<ng-container *ngFor="let item of menuItems">
		<button (click)="item.action()" mat-menu-item>
			{{ item.label | translate}}
		</button>
	</ng-container>
</mat-menu>
